
import { defineComponent } from 'vue'
import ButtonLoader from '@/components/Loaders/ButtonLoader.vue'

export default defineComponent({
	name: 'PrimaryButton',

	components: { ButtonLoader },

	emits: ['click'],

	props: {
		outlined: {
			type: Boolean,
			default: false
		},

		disabled: {
			type: Boolean,
			default: false
		},

		large: {
			type: Boolean,
			default: false
		},

		fullWidth: {
			type: Boolean,
			default: false
		},

		loading: {
			type: Boolean,
			default: false
		},

		lighter: {
			type: Boolean,
			default: false
		},

		rounded: {
			type: Boolean,
			default: true
		},

		darkTheme: {
			type: Boolean,
			default: false
		}
	},

	setup(props, { emit }) {
		// Methods
		const onClick = () => {
			if (props.loading) return

			emit('click')
		}

		return { onClick }
	}
})
